<template>
  <div>
    <!-- video-->
    <video
      v-if="stream_mode == 'video'"
      ref="videoPlayer"
      class="video-js vjs-16-9 vjs-big-play-centered"
      playsinline="true"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)"
      @error="onPlayerError($event)"
      @retryplaylist="onPlayerRetryPlaylist($event)"
    ></video>
    <!-- youtube / vimeo -->
    <div v-if="stream_mode == 'embed'" class="video-container">
      <!-- <iframe
        :src="stream_url"
        frameborder="0"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe> -->
      <iframe
        :src="embedUrl"
        title="Onseminar"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <v-text-field
      v-if="stream_mode == 'embed'"
      class="mt-5 text-caption"
      :value="stream_url"
      label="Original Url"
      disabled
    ></v-text-field>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
const APP_BASE_URL = process.env.VUE_APP_BASE_URL;

import videojs from "video.js";
export default {
  name: "VideoPlayer",
  props: [
    "options",
    "poster",
    "stream_mode",
    "stream_url",
    "stream_timelimit",
    "autoplay",
    "content_id",
  ],
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    console.log(
      "[플레이어 다시그리기]",
      this.stream_mode,
      this.stream_url,
      this.stream_timelimit,
      this.poster
    );

    if (this.stream_mode == "video") {
      // videojs.Vhs.xhr.beforeRequest = options => {
      //   if (options.uri.includes("m3u8")) {
      //     const tokenString = this.$store.state.user.idToken;
      //     options.uri =
      //       options.uri +
      //       `?&_=${Date.now()}&cm=1&t=${encodeURIComponent(
      //         this.stream_timelimit
      //       )}`;
      //     //console.log("options", options);
      //   }
      //   // if (this.autoplay) {
      //   //   options.autoplay = true;
      //   // }
      //   return options;
      // };

      let url = `${APP_BASE_URL}${
        this.stream_url
      }?_=${Date.now()}&t=${encodeURIComponent(this.stream_timelimit)}`;
      this.options.sources[0].src = url;
      this.options.autoplay = false; // 관리자 모드라 오토플레이 안함
      this.options.muted = true; // 관리자 모드라 뮤트 함

      this.player = videojs(
        this.$refs.videoPlayer,
        this.options,
        function onPlayerReady() {
          console.log("onPlayerReady", this);
        }
      );

      if (this.poster) {
        const posterUrl = APP_BASE_URL + "/" + this.poster + "?_=" + Date.now();
        this.player.poster(posterUrl);
      }
    }
  },
  computed: {
    embedUrl: function () {
      let url;
      const youtubePattern =
        /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      const isYoutube = youtubePattern.test(this.stream_url);

      // const vimeoPattern = /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
      const vimeoPattern =
        /(?:http|https)?:?\/?\/?(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|video\/|event\/|)(\d+)(?:|\/\?)/;
      const isVimeo = vimeoPattern.test(this.stream_url);

      if (isYoutube) {
        const result = this.stream_url.match(youtubePattern);
        const id = result[5];

        url = "https://www.youtube.com/embed/" + id;
        if (this.autoplay) {
          url = url + "?autoplay=1";
        }
      }

      if (isVimeo) {
        const result = this.stream_url.match(vimeoPattern);
        const id = result[1];
        url = "https://player.vimeo.com/video/" + id;
        if (this.autoplay) {
          url = url + "?autoplay=1";
        }
      }

      return url;
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded(player) {
      // console.log('player ended!', player)
    },
    onPlayerLoadeddata(player) {
      // console.log('player Loadeddata!', player)
    },
    onPlayerWaiting(player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying(player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate(player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay(player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    },
    // error
    onPlayerError(player) {
      console.log("player error!", player);
    },
    // error
    onPlayerRetryPlaylist(player) {
      console.log("player error!", player);
    },
    // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
  },
};
</script>
<style src="@/assets/css/video-js.min.css"></style>
<style>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
